import { useLayoutEffect } from 'react';
import type { RefObject } from 'react';
import gsap from 'gsap';
import { usePreferences } from '@/hooks';
import { prefersReducedMotion } from '@/app/shell/Backdrop/prefersReducedMotion';

/** One-shot entrance for the auth card. No-op under reduced motion (pref or OS).
 *  Uses useLayoutEffect so the initial autoAlpha:0 is applied before first paint
 *  (avoids a one-frame flash). Safe here — this app is client-only (no SSR). */
export function useAuthEntrance(ref: RefObject<HTMLElement | null>) {
  const { prefs } = usePreferences();
  const motionOff = prefs.reduceMotion || prefersReducedMotion();
  useLayoutEffect(() => {
    if (motionOff || !ref.current) return;
    const tween = gsap.fromTo(
      ref.current,
      { autoAlpha: 0, y: 18 },
      { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power2.out' },
    );
    return () => { tween.kill(); };
  }, [motionOff, ref]);
}
